import { render, staticRenderFns } from "./TextContentEdit.vue?vue&type=template&id=db071600"
import script from "./TextContentEdit.vue?vue&type=script&lang=js"
export * from "./TextContentEdit.vue?vue&type=script&lang=js"
import style0 from "./TextContentEdit.vue?vue&type=style&index=0&id=db071600&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports